import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

import type { CustomField } from '@sales-center/common'
import type { StoreData } from '../reducers/typings'
import {
  getCustomFieldById,
  getAllCustomFields,
  addCustomField,
  updateCustomField,
  removeCustomField,
} from './api'

const customFieldsAdapter = createEntityAdapter<CustomField>()

export const customFieldsInitialState = customFieldsAdapter.getInitialState()

const customFieldsSlice = createSlice({
  name: 'customFieldsSlice',
  initialState: customFieldsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomFieldById.fulfilled, (state, { payload }) => {
      const { options, ...customField } = payload
      customFieldsAdapter.upsertOne(state, customField)
    })

    builder.addCase(getAllCustomFields.fulfilled, (state, { payload }) => {
      const fields = payload.map(({ options, ...field }) => field)
      customFieldsAdapter.setAll(state, fields)
    })

    builder.addCase(addCustomField.fulfilled, (state, { payload }) => {
      const { options, ...customField } = payload
      customFieldsAdapter.addOne(state, customField)
    })

    builder.addCase(updateCustomField.fulfilled, (state, { payload }) => {
      const { options, ...customField } = payload
      customFieldsAdapter.upsertOne(state, customField)
    })

    builder.addCase(removeCustomField.fulfilled, (state, { meta: { arg } }) => {
      customFieldsAdapter.removeOne(state, arg)
    })
  },
})

export const customFieldsReducer = customFieldsSlice.reducer

export const { selectAll: selectAllCustomFields } =
  customFieldsAdapter.getSelectors<StoreData>((state) => state.customFields)
